module.exports = __webpack_public_path__ + "static/media/un_sdg_free.81ffc110.png";